//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Features.js";
let d=[[[1,"BraceFace",0,"ScCollector",0],[1,"Clearance",0,"Expression",0],[0,"Disabled",1,0],[0,"LappedPlateAttachedMember",1,0],[0,"Modified",1,0],[0,"PreviewGenerator",1,"Features.StructureDesign.BoltedConnectionBuilder",0],[0,"ReferenceFace",1,0],[1,"StockData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0]],[[["sectionModified"],"UpdateStockSectionTypes",{},1,0],[[],"ResetFromParms",{},0,0],[["selectedBuilders"],"CloneDataToSelectedBuilders",{},1,0]],[]];
SPLM.Features.StructureDesign.GussetConnectionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.GussetConnectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.GussetConnectionBuilder.JaBoltedConnectionBuilderGussetconnectionreferenceface = Object.freeze({
    "AnchorFace" : "AnchorFace", "AttachmentFace" : "AttachmentFace"});

export default SPLM;